import '../Profile.css'
import ButtonMedium4 from "components/elements/ButtonMedium4"
import { Accordion, AccordionDetails, AccordionSummary, Box, useMediaQuery } from "@mui/material"
import ContentNormal from "components/elements/ContentNormal"
import { useNavigate } from "react-router-dom"
import Headline4 from "components/elements/Headline4"
import { callAPI } from "utils/API"
import { useContext, useEffect, useState } from "react"
import { AppContext } from "contexts/AppContext"
import moment from "moment"
import { priceConvertor } from "utils/general"
import Headline2 from "components/elements/Headline2"
import { translate } from "utils/Translate"
import CircularIndeterminate from "components/blocks/progressBar/progressBar"
import RoundIconButton1 from "components/elements/RoundIconButton1"
import CaretDown from "components/icons/CaretDown"
import { setupUserData } from "utils/setup"
import Sales from "components/blocks/Sales/Sales"
import { Modal } from "react-bootstrap"
import Headline6 from "components/elements/Headline6"
import ButtonMedium1 from "components/elements/ButtonMedium1"
import { PointOverview } from '../PointsOverview'


const PointsPage = () => {
    const contextState = useContext(AppContext)
    const { styleGuide, langCode, brandData, userData, accessibleShops, themeConfig } = contextState
    const [userPoints, setUserPoints] = useState({})
    const [starkUserWallet, setStarkUserWallet] = useState([])
    const [automaticActivationEnabled, setAutomaticActivationEnabled] = useState(userData.enableAutoWalletActivation === 1)
    const [showAutomaticActivationDialog, setShowAutomaticActivationDialog] = useState(false)
    const [loading, setLoading] = useState(true)
    const [activateComplete, setActivateComplete] = useState(false)
    const [walletActivationLines, setWalletActivationLines] = useState([])
    const [walletLines, setWalletLines] = useState([])
    const [salesToActivate, setSalesToActivate] = useState([])
    const [showActivationModal, setShowActivationModal] = useState(false)
    
    const isStarkBrand = brandData.BrandID === 87
    const defaultShopID = accessibleShops && accessibleShops.length > 0
        ? accessibleShops[0].ShopID
        : null;
    const activationPointsSectionLabels = brandData.features?.upgraderClubConfigurableLabels && brandData.features.upgraderClubConfigurableLabels[langCode]?.profilePageLabels?.activationPointsSectionLabels
        ? brandData.features.upgraderClubConfigurableLabels[langCode].profilePageLabels.activationPointsSectionLabels : null
    const { enableWalletActivation, enableWalletExpiry, disableProfilePointsOverviewGrid, walletActivationText, disableAutoActivateFeature, disableProfilePointsOverview } = brandData?.features || {}
    const walletExpiryMonths = Number(brandData?.features?.walletExpiryMonths) || 12

    const fetchWalletActivation = async () => {
        const userWalletActivationLines = await callAPI(`/walletactivation/userPool`);
        if (!userWalletActivationLines || !userWalletActivationLines.length) {
            setWalletActivationLines([]);
        } else {
            setWalletActivationLines(userWalletActivationLines)
        }
    }

    const fetchWalletLines = async () => {
        const userWalletLines = await callAPI(`/user/walletLines`);
        if (!userWalletLines || !userWalletLines.length) {
            setWalletLines([]);
        } else {
            setWalletLines(userWalletLines)
        }
    }

    const fetchPointsStark = async () => {
        const pointsHistory = await callAPI('/stark/getPointsHistory', 'GET', {}, null, userData.selectedCustomerNumber)
        const userWalletLines = pointsHistory.transactions;
        if (!userWalletLines || !userWalletLines.length) return

        const userWallet = []
        for (const walletLine of userWalletLines) {
            const walletObj = {
                expirationDate: walletLine.expirationDate ? moment(walletLine.expirationDate) : undefined,
                remainingPoints: walletLine.remainingPoints ? walletLine.remainingPoints : 0
            }
            userWallet.push(walletObj);
        }

        setLoading(false)
        setStarkUserWallet(userWallet)
    }

    const fetchActivePoints = async () => {
        let response = await callAPI("/user/getWalletActivationProfileStats", "GET")
        if (response) {
            setUserPoints(response)
        }
        setLoading(false)
        setActivateComplete(false)
    }

    const showActivatePointsModal = (sales) => {
        setSalesToActivate(sales)
        setShowActivationModal(true)
    }

    const handleAutomaticActivationClick = () => {
        setShowAutomaticActivationDialog(true)
    }

    const activatePoints = async () => {
        const WalletActivationIDs = salesToActivate.map(s => s.WalletActivationID)
        if (WalletActivationIDs.length) {
            const request = await callAPI(`/walletactivation/updateStatusUser`, "POST", { body: { WalletActivationIDs } })
            if (request) {
                setShowActivationModal(false)
                setActivateComplete(true)
                setupUserData(contextState, setLoading)
                fetchWalletActivation()
                setWalletActivationLines(walletActivationLines.map(sale => ({...sale, checked: false})))

                const activatedSum = salesToActivate.reduce((sum, s) => sum + s.walletAmountPoints, 0)
                if(activatedSum === sumExpiringInLargeMonths){
                    handleAutomaticActivationClick()
                }
            }
        }
    }

    const getSelectedPointsBalance = () => {
        return salesToActivate.filter(s => s.status === 'WAITING' || s.status === 'COMPENSATION').reduce((sum, s) => sum + s.walletAmountPoints, 0)
    }

    const getModalContent = () => {
        const selectedSales = salesToActivate
        const totalPoints = selectedSales.reduce((sum, a) => sum + a.walletAmountPoints, 0)
        if (!selectedSales.length) {
            return `Please select at least one item`
        } else {
            const balanceAmount = getSelectedPointsBalance()
            if (balanceAmount >= 0) {
                const compensationPoints = walletActivationLines.filter(s => s.status === 'COMPENSATION').reduce((sum, a) => sum + a.walletAmountPoints * -1, 0)
                if (totalPoints >= compensationPoints) {
                    const confirmText = activationPointsSectionLabels?.popupContentText ? activationPointsSectionLabels.popupContentText.replace("{{walletAmountPoints}}", totalPoints).replace("{{totalSales}}", selectedSales.length) :
                        `Er du sikker på, at du vil aktivere ${totalPoints} point?`
                    return <>
                        {confirmText}
                        <br />
                        <br />
                        {'Aktiverede point ikke kan deaktiveres, hverken af xx eller Upgrader, og vil blive indberettet til Skattestyrelsen.'.replace('xx', brandData?.brandName)}
                        {compensationPoints > 0
                            ? <><br /><br />{`Bemærk at ${compensationPoints} point ikke vil blive aktiveret, da de udlignes af dine udligningspoint.`}</>
                            : ''
                        }
                    </>
                } else {
                    return activationPointsSectionLabels?.popupContentTextCompensationNotAllowed ? activationPointsSectionLabels.popupContentTextCompensationNotAllowed :
                        `Den valgte sum af point er mindre end summen af dine udligningspoint (${compensationPoints}). Du skal vælge flere point for at kunne aktivere dem.`
                }
            } else {
                return activationPointsSectionLabels?.popupContentTextCompensation ? activationPointsSectionLabels.popupContentTextCompensation :
                    `Din sum af point til aktivering er negativ p.g.a. udligningspoint og du kan derfor ikke aktivere flere point.`
            }
        }
    }

    useEffect(() => {
        if(isStarkBrand){
            fetchPointsStark()
        } else {
            fetchActivePoints()
            fetchWalletActivation()

            if(enableWalletExpiry){
                fetchWalletLines()
            }
        }
    }, [])

    useEffect(() => {
        if(activateComplete){
            fetchActivePoints()
        }
    }, [activateComplete])

    const activatedPoints = isStarkBrand
        ? priceConvertor(brandData, userData.walletAmountPoints || 0, '')
        : priceConvertor(brandData, userPoints?.walletBalance || 0, '')
    const totalPoints = priceConvertor(brandData, userPoints?.walletBalance + userPoints?.walletActivationBalance || 0, '')

    const fiveMonthsAgo = moment().subtract(5, 'months').startOf('month').utc()
    const twoMonthsAgo = moment().subtract(2, 'months').startOf('month').utc()
    const expiringThisMonth = walletActivationLines.filter(s => s.status === "WAITING" && moment(s.timeInsert).isBefore(fiveMonthsAgo))
    const expiringInMediumMonths = walletActivationLines.filter(s => s.status === 'WAITING' && moment(s.timeInsert).isBefore(twoMonthsAgo))
    const expiringInLargeMonths = walletActivationLines.filter(s => s.status === 'WAITING')

    
    let sumExpiringThisMonth = 0
    let sumExpiringInMediumMonths = 0
    let sumExpiringInLargeMonths = 0
    if(isStarkBrand){ // Stark has different expiry logic than other brands, so we need to handle it differently
        const now = moment()
        const inThreeMonths = moment().add(3, 'months')
        const inSixMonths = moment().add(6, 'months')

        sumExpiringThisMonth = starkUserWallet.filter(w => w.expirationDate && w.expirationDate.year() === now.year() && w.expirationDate.month() === now.month()).reduce((sum, s) => sum + s.remainingPoints, 0)
        sumExpiringInMediumMonths = starkUserWallet.filter(w => w.expirationDate && w.expirationDate > now && w.expirationDate <= inThreeMonths).reduce((sum, s) => sum + s.remainingPoints, 0)
        sumExpiringInLargeMonths = starkUserWallet.filter(w => w.expirationDate && w.expirationDate > now && w.expirationDate <= inSixMonths).reduce((sum, s) => sum + s.remainingPoints, 0)
    } else if (enableWalletActivation) {
        sumExpiringThisMonth = expiringThisMonth.reduce((sum, s) => sum + s.walletAmountPoints, 0)
        sumExpiringInMediumMonths = expiringInMediumMonths.reduce((sum, s) => sum + s.walletAmountPoints, 0)
        sumExpiringInLargeMonths = expiringInLargeMonths.reduce((sum, s) => sum + s.walletAmountPoints, 0)
    } else if (enableWalletExpiry) {
        const endOfMonthExpiryCutoff = moment().subtract(walletExpiryMonths - 1, 'months').startOf('month').utc()
        const threeMonthsExpiryCutoff = moment().subtract(walletExpiryMonths - 4, 'months').startOf('month').utc()
        const sixMonthsExpiryCutoff = moment().subtract(walletExpiryMonths - 7, 'months').startOf('month').utc()
        const negativeSum = walletLines.filter(s => s.walletAmountPoints < 0).reduce((sum, s) => sum + s.walletAmountPoints, 0)
        const positiveSumEndOfMonth = walletLines.filter(s => s.walletAmountPoints > 0 && moment(s.timeInsert).isBefore(endOfMonthExpiryCutoff)).reduce((sum, s) => sum + s.walletAmountPoints, 0)
        const positiveSumInThreeMonths = walletLines.filter(s => s.walletAmountPoints > 0 && moment(s.timeInsert).isBefore(threeMonthsExpiryCutoff)).reduce((sum, s) => sum + s.walletAmountPoints, 0)
        const positiveSumInSixMonths = walletLines.filter(s => s.walletAmountPoints > 0 && moment(s.timeInsert).isBefore(sixMonthsExpiryCutoff)).reduce((sum, s) => sum + s.walletAmountPoints, 0)
        sumExpiringThisMonth = positiveSumEndOfMonth + negativeSum > 0 ? positiveSumEndOfMonth + negativeSum : 0
        sumExpiringInMediumMonths = positiveSumInThreeMonths + negativeSum > 0 ? positiveSumInThreeMonths + negativeSum : 0
        sumExpiringInLargeMonths = positiveSumInSixMonths + negativeSum > 0 ? positiveSumInSixMonths + negativeSum : 0
    }

    const pointsSuffix = translate("_POINTS_", "point")

    return (
        <Box flex={1} display={'flex'} flexDirection={'column'} gap={6}>
            {!disableProfilePointsOverviewGrid && (!!enableWalletActivation
                ?
                    <PointActivationOverviewGrid
                        activatedPoints={activatedPoints}
                        pointsForActivation={priceConvertor(brandData, sumExpiringInLargeMonths, ' ')}
                        defaultShopID={defaultShopID}
                        loading={loading}
                        totalPoints={totalPoints}
                        sales={walletActivationLines}
                        showActivatePointsModal={showActivatePointsModal}
                    />
                :
                    <PointOverviewGrid
                        currentPoints={activatedPoints}
                        walletBalance={userPoints?.walletBalance || 0}
                        brandData={brandData}
                        defaultShopID={defaultShopID}
                        loading={loading}
                    />
            )}

            <Box
                display={'flex'}
                flexDirection={'column'}
                gap={2}
            >
                {!!walletActivationText &&
                    <div
                        dangerouslySetInnerHTML={{ __html: walletActivationText }}
                        style={{
                            fontFamily: styleGuide.fontFamily,
                            fontSize: styleGuide.headline5FontSize,
                            fontStyle: 'normal',
                            lineHeight: styleGuide.headline3LineHeight,
                            color: styleGuide.color7,
                        }}
                    />
                }

                {!!enableWalletActivation &&
                    <Accordion
                        className="profileAccordion"
                        defaultExpanded={true}
                    >
                        <AccordionSummary
                            className="profileAccordionSummary"
                            expandIcon={<RoundIconButton1 icon={<CaretDown fill="white" />} />}
                        >
                            <Box flexDirection={'column'}>
                                <Headline4
                                    configuredLabel={activationPointsSectionLabels?.sectionBoxTitleText}
                                    translationKey="_PROFILE_PAGE_POINT_APPROVAL_CAPTION_"
                                    fallbackText="Point til aktivering"
                                />
                                <Box display={'flex'} marginTop={2} gap={2} flexWrap={'wrap'}>
                                    <ButtonMedium4 showIcon={false}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            showActivatePointsModal(expiringInLargeMonths)
                                        }}
                                        translationKey="_ACTIVATE_ALL_POINTS_"
                                        fallbackText="Aktivér alle point"
                                    />
                                    {!disableAutoActivateFeature && (automaticActivationEnabled
                                        ?
                                        <ButtonMedium4 showIcon={false}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleAutomaticActivationClick()
                                            }}
                                            translationKey="_DISABLE_AUTOMATIC_ACTIVATION_"
                                            fallbackText="Afmeld automatisk aktivering"
                                        />
                                        :
                                        <ButtonMedium4 showIcon={false}
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleAutomaticActivationClick()
                                            }}
                                            translationKey="_ENABLE_AUTOMATIC_ACTIVATION_"
                                            fallbackText="Tilmeld automatisk aktivering"
                                        />
                                    )}
                                </Box>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails
                            className="profileAccordionDetails"
                            style={{
                                borderTop: `1px solid ${styleGuide.color4}`,
                            }}
                        >
                            <Sales
                                setActivateComplete={setActivateComplete}
                                sales={walletActivationLines}
                                setSales={setWalletActivationLines}
                                refreshData={fetchWalletActivation}
                                setShowModal={() => showActivatePointsModal(walletActivationLines.filter(s => !!s.checked))}
                            />
                        </AccordionDetails>
                    </Accordion>
                }

                {!brandData?.features?.disableProfilePointsExpiryOverview &&
                    <Accordion
                        className="profileAccordion"
                        defaultExpanded={true}
                    >
                        <AccordionSummary
                            className="profileAccordionSummary"
                            expandIcon={<RoundIconButton1 icon={<CaretDown fill="white" />} />}
                        >
                            <Box display={'flex'} flexDirection='column' gap={2}>
                                <Headline4
                                    translationKey="_EXPIRING_POINTS_OVERVIEW"
                                    fallbackText="Overblik over point til udløb"
                                />
                                {!!enableWalletActivation &&
                                    <Box display={'flex'} gap={2} flexWrap={'wrap'}>
                                        <ButtonMedium4 showIcon={false}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                showActivatePointsModal(expiringInLargeMonths);
                                            }}
                                            translationKey="_ACTIVATE_ALL_POINTS_"
                                            fallbackText="Aktivér alle point"
                                        />
                                        {!disableAutoActivateFeature && (!!automaticActivationEnabled
                                            ?
                                            <ButtonMedium4 showIcon={false}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleAutomaticActivationClick()
                                                }}
                                                translationKey="_DISABLE_AUTOMATIC_ACTIVATION_"
                                                fallbackText="Afmeld automatisk aktivering"
                                            />
                                            :
                                            <ButtonMedium4 showIcon={false}
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    handleAutomaticActivationClick()
                                                }}
                                                translationKey="_ENABLE_AUTOMATIC_ACTIVATION_"
                                                fallbackText="Tilmeld automatisk aktivering"
                                            />
                                        )}
                                    </Box>
                                }
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails
                            style={{
                                borderTop: `1px solid ${styleGuide.color4}`,
                                overflow: 'scroll'
                            }}
                            className="hide-scroll profileAccordionDetails"
                        >
                            <Box display={'flex'} flexDirection={'column'} gap={1}>
                                <ContentNormal style={{ fontWeight: 600 }}>
                                    {translate('_PROFILE_POINTS_EXPIRY_HEADLINE_', 'Point udløber 6 mdr. efter de er tildelt')}
                                </ContentNormal>
                                <ContentNormal>
                                    {translate('_PROFILE_POINTS_EXPIRY_DESCRIPTION_1_', 'Point udløber 6 mdr. efter de er blevet tildelt, med mindre du aktiverer dem.')}
                                    <br />
                                    {translate('_PROFILE_POINTS_EXPIRY_DESCRIPTION_2_', `Aktiverede point er tilgængelige så længe du er medlem af xx.`).replace('xx', brandData.brandName)}
                                </ContentNormal>
                            </Box>
                            <Box display={'flex'} gap={4} marginTop={4} flexWrap={'wrap'}>
                                <PointOverviewBox
                                    headline={translate('_EXPIRING_THIS_MONTH_', 'Udløber denne måned')}
                                    points={priceConvertor(brandData, sumExpiringThisMonth, pointsSuffix)}
                                    buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                                    buttonFunction={() => showActivatePointsModal(expiringThisMonth)}
                                    textColor={styleGuide.color12}
                                    loading={loading}
                                    disabled={expiringThisMonth.length <= 0}
                                    hideButton={!enableWalletActivation}
                                />

                                <PointOverviewBox
                                    headline={translate('_EXPIRING_IN_MEDIUM_MONTHS_', 'Udløber inden for tre måneder')}
                                    points={priceConvertor(brandData, sumExpiringInMediumMonths, pointsSuffix)}
                                    buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                                    buttonFunction={() => showActivatePointsModal(expiringInMediumMonths)}
                                    textColor={styleGuide.color7}
                                    loading={loading}
                                    disabled={expiringInMediumMonths.length <= 0}
                                    hideButton={!enableWalletActivation}
                                />

                                <PointOverviewBox
                                    headline={translate('_EXPIRING_IN_LARGE_MONTHS_', 'Udløber inden for seks måneder')}
                                    points={priceConvertor(brandData, sumExpiringInLargeMonths, pointsSuffix)}
                                    buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                                    buttonFunction={() => showActivatePointsModal(expiringInLargeMonths)}
                                    textColor={styleGuide.color7}
                                    loading={loading}
                                    disabled={expiringInLargeMonths.length <= 0}
                                    hideButton={!enableWalletActivation}
                                />
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                }

                {!disableProfilePointsOverview && (!themeConfig.disablePoints && <PointOverview activateComplete={activateComplete} setActivateComplete={setActivateComplete} defaultExpanded={!enableWalletActivation} />)}
            </Box>

            <Modal
                show={showActivationModal}
                onHide={() => setShowActivationModal(false)}
                style={{ margin: "auto" }}
                centered
            >
                <Modal.Header
                    className="pb-0 border-0"
                    closeButton
                    style={{ fontSize: 9 }}
                >
                    <Headline6 translationKey="_CONFIRM_ACTIVATE_SALES_HEADING_">
                        {activationPointsSectionLabels?.popupTitleText ? activationPointsSectionLabels.popupTitleText : 'Bekræft aktivering'}
                    </Headline6>
                </Modal.Header>
                <Modal.Body>
                    <ContentNormal style={{ whiteSpace: "pre-line" }}>
                        {getModalContent()}
                    </ContentNormal>
                </Modal.Body>
                <Modal.Footer>
                    <Box display={'flex'} justifyContent={'flex-end'} gap={1}>
                        {getSelectedPointsBalance() >= 0 && !!salesToActivate.length && (salesToActivate.reduce((sum, a) => sum + a.walletAmountPoints, 0) >= walletActivationLines.filter(s => s.status === 'COMPENSATION').reduce((sum, a) => sum + a.walletAmountPoints * -1, 0)) &&
                            <ButtonMedium1
                                showIcon={false}
                                translationKey="_YES_"
                                fallbackText="Ja"
                                onClick={() => activatePoints()}
                            />
                        }
                        <ButtonMedium4
                            showIcon={false}
                            translationKey="_CLOSE_"
                            fallbackText="Fortryd"
                            onClick={() => {
                                setWalletActivationLines(walletActivationLines.map(s => {
                                    s.checked = false
                                    return s
                                }))
                                setShowActivationModal(false)
                            }}
                        />
                    </Box>
                </Modal.Footer>
            </Modal>

            <ConfirmAutomaticActivationDialog
                open={showAutomaticActivationDialog}
                setOpen={setShowAutomaticActivationDialog}
                activate={automaticActivationEnabled}
                setActivate={setAutomaticActivationEnabled}
            />
        </Box>
    )
}

export default PointsPage

const PointActivationOverviewGrid = (props) => {
    const navigate = useNavigate()
    const { styleGuide, brandData } = useContext(AppContext)
    const boxBgColor = brandData?.features?.profileBoxBgColor || styleGuide.color3

    return (
        <Box display={'flex'} gap={4} flexWrap={'wrap'}>
            <PointOverviewBox
                headline={translate('_HEADER_ACTIVATED_POINTS_', 'Aktiverede point')}
                points={props.activatedPoints}
                buttonText={'Shop'}
                buttonFunction={() => navigate(`/shop/${props.defaultShopID}`, { state: { scrollToTop: true } })}
                textColor={styleGuide.color8}
                loading={props.loading}
            />

            <Box flex={3} style={{ backgroundColor: boxBgColor, borderRadius: 14, minWidth: 300 }} padding={4}>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <ContentNormal
                        style={{ textAlign: 'center' }}
                        translationKey="_TOTAL_AMOUNT_POINTS_"
                        fallbackText="Samlet antal point"
                    />

                    {props.loading
                        ?
                        <Box display={'flex'} justifyContent={'center'}>
                            <CircularIndeterminate />
                        </Box>
                        :
                        <Headline2 style={{ textAlign: 'center' }}>
                            {props.totalPoints}
                        </Headline2>
                    }

                    <Box display={'flex'} justifyContent={'center'}>
                        <ContentNormal
                            translationKey="_TOTAL_AMOUNT_POINTS_DESCRIPTION_"
                            fallbackText="Summen af aktiverede + ikke-aktiverede point"
                            style={{textAlign: 'center'}}
                        />
                    </Box>
                </Box>
            </Box>

            <PointOverviewBox
                headline={translate('_POINTS_FOR_ACTIVATION_', 'Point til aktivering')}
                points={props.pointsForActivation}
                buttonText={translate("_ACTIVATE_POINTS_", "Aktivér point")}
                buttonFunction={() => props.showActivatePointsModal(props.sales.filter(s => s.status === "WAITING"))}
                textColor={styleGuide.color12}
                loading={props.loading}
            />
        </Box>
    )
}

const PointOverviewGrid = (props) => {
    const navigate = useNavigate()
    const { styleGuide, brandData } = useContext(AppContext)
    const [usedPoints, setUsedPoints] = useState(0)
    const boxBgColor = brandData?.features?.profileBoxBgColor || styleGuide.color3

    const fetchUsedPoints = async () => {
        let response = await callAPI("/user/usedPoints", "GET");
        if (response) {
            setUsedPoints(response)
        }
    }

    useEffect(() => {
        fetchUsedPoints()
    }, [])

    return (
        brandData?.features?.simplePointsOverviewGrid
            ?
                <Box maxWidth={500}>
                    <PointOverviewBox
                        headline={translate('_PROFILE_POINTS_AVAILABLE_', 'Point til rådighed')}
                        points={props.currentPoints}
                        buttonText={'Shop'}
                        buttonFunction={() => navigate(`/shop/${props.defaultShopID}`, { state: { scrollToTop: true } })}
                        textColor={styleGuide.color8}
                        loading={props.loading}
                    />
                </Box>
            :
                <Box display={'flex'} gap={4} flexWrap={'wrap'}>
                    <PointOverviewBox
                        headline={translate('_PROFILE_POINTS_AVAILABLE_', 'Point til rådighed')}
                        points={props.currentPoints}
                        buttonText={'Shop'}
                        buttonFunction={() => navigate(`/shop/${props.defaultShopID}`, { state: { scrollToTop: true } })}
                        textColor={styleGuide.color8}
                        loading={props.loading}
                    />

                    <Box flex={3} style={{ backgroundColor: boxBgColor, borderRadius: 14, minWidth: 300 }} padding={4}>
                        <Box display={'flex'} flexDirection={'column'} gap={4}>
                            <ContentNormal
                                style={{ textAlign: 'center' }}
                                translationKey="_TOTAL_AMOUNT_POINTS_"
                                fallbackText="Samlet antal point"
                            />

                            {props.loading
                                ?
                                <Box display={'flex'} justifyContent={'center'}>
                                    <CircularIndeterminate />
                                </Box>
                                :
                                <Headline2 style={{ textAlign: 'center' }}>
                                    {priceConvertor(props.brandData, usedPoints + props.walletBalance, ' ')}
                                </Headline2>
                            }

                            <Box display={'flex'} justifyContent={'center'}>
                                <ContentNormal
                                    translationKey="_PROFILE_TOTAL_POINTS_AVAILABLE_USED_"
                                    fallbackText="Summen af point til rådighed + brugte point"
                                    style={{textAlign: 'center'}}
                                />
                            </Box>
                        </Box>
                    </Box>

                    <PointOverviewBox
                        headline={translate('_PROFILE_POINTS_USED_', 'Brugte point')}
                        points={priceConvertor(props.brandData, usedPoints, ' ')}
                        textColor={styleGuide.color12}
                        loading={props.loading}
                        hideButton
                    />
                </Box>
    )
}

const PointOverviewBox = (props) => {
    const { brandData, styleGuide } = useContext(AppContext)
    const isMobile = useMediaQuery('(max-width:500px)')
    const boxBgColor = brandData?.features?.profileBoxBgColor || styleGuide.color3

    return (
        <Box flex={2} style={{ backgroundColor: boxBgColor, borderRadius: 14, minWidth: isMobile ? 260 : 320 }} padding={4}>
            <Box display={'flex'} flexDirection={'column'} gap={4}>
                <ContentNormal style={{ textAlign: 'center' }} fallbackText={props.headline} />

                <Headline2 style={{ textAlign: 'center', color: props.textColor }}>
                    {props.loading
                        ? 
                            <Box display={'flex'} justifyContent={'center'}>
                                <CircularIndeterminate />
                            </Box>
                        :
                            props.points
                    }
                </Headline2>

                <Box display={'flex'} justifyContent={'center'}>
                    {!props.hideButton &&
                        <ButtonMedium4
                            showIcon={false}
                            onClick={props.buttonFunction}
                            disabled={props.disabled}
                        >
                            {props.buttonText}
                        </ButtonMedium4>
                    }
                </Box>
            </Box>
        </Box>
    )
}

export const ConfirmAutomaticActivationDialog = (props) => {
    const { activate, setActivate, open, setOpen } = props;
    const { userData, setUserData } = useContext(AppContext);

    const handleClose = () => {
        setOpen(false);
    }

    const handleAgree = async () => {
        let response = await callAPI("/user/toggleAutoWalletActivation", "POST");
        if (response) {
            setUserData({ ...userData, enableAutoWalletActivation: userData.enableAutoWalletActivation === 1 ? 0 : 1 })
            setActivate(!activate)
        }
        setOpen(false);
    }

    return (
        <Modal
            show={open}
            onHide={handleClose}
            style={{ margin: "auto" }}
            centered
        >
            <Modal.Header
                className="pb-0 border-0"
                closeButton
                style={{ fontSize: 9 }}
            >
                <Headline6
                    translationKey="_AUTOMATIC_ACTIVATION_"
                    fallbackText="Automatisk aktivering"
                />
            </Modal.Header>
            <Modal.Body>
                <ContentNormal>
                    {activate
                        ? translate('_MANUAL_ACTIVATION_OF_SALES_', 'Vil du ændre din indstilling til manuel aktivering af dine point?')
                        : translate('_AUTOMATIC_ACTIVATION_OF_SALES_', 'Vil du aktivere alle point automatisk? Bemærk at aktiverede point indberettes til Skattestyrelsen')
                    }
                </ContentNormal>
            </Modal.Body>
            <Modal.Footer>
                <ButtonMedium1 showIcon={false} translationKey="_ACCEPT_" fallbackText="Godkend" onClick={handleAgree} />
                <ButtonMedium4 showIcon={false} translationKey="_CANCEL_" fallbackText="Afvis" onClick={handleClose} />
            </Modal.Footer>
        </Modal>
    );
};